module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shift-layout"
  }, [_c('div', {
    staticClass: "user-pool",
    on: {
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDrop('unset', $event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.onDragover($event)
      }
    }
  }, [_c('h6', [_vm._v("帳號清單")]), _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "user-item",
      attrs: {
        "id": ("user-" + (user.id)),
        "userid": user.id,
        "draggable": "draggable"
      },
      on: {
        "drag": function($event) {
          return _vm.onDrag($event)
        }
      }
    }, [_vm._v(_vm._s(user.last_name) + _vm._s(user.first_name))])
  })], 2), _c('div', {
    staticClass: "shift-schedule"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("排程日期")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentDate),
      expression: "currentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.currentDate)
    },
    on: {
      "change": function($event) {
        return _vm.getShift(_vm.currentDate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentDate = $event.target.value
      }
    }
  })]), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.shiftTable), function(shiftRow) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', {
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v(_vm._s(shiftRow.bed.code))]), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('response', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.response), function(shift) {
      return (shiftRow.response.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('circular', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.circular), function(shift) {
      return (shiftRow.circular.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('management', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.management), function(shift) {
      return (shiftRow.management.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("床號")]), _c('th', [_vm._v("值班人員")]), _c('th', [_vm._v("流動人員 ")]), _c('th', [_vm._v("負責人員")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b3fe7d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/ShiftArrange.vue
// module id = 1379
// module chunks = 1